import { useStorage } from '@vueuse/core'
import type { Ref } from 'vue'

const fallback = new Map<string, string>()

/** localStorage that falls back to memory when the browser blocks storage. */
export const safeStorage = {
    getItem(key: string) {
        try {
            return window.localStorage.getItem(key)
        } catch {
            return fallback.get(key) ?? null
        }
    },
    setItem(key: string, value: string) {
        try {
            window.localStorage.setItem(key, value)
        } catch {
            fallback.set(key, value)
        }
    },
    removeItem(key: string) {
        try {
            window.localStorage.removeItem(key)
        } catch {
            fallback.delete(key)
        }
    },
}

/** A per-browser UI preference (panel state, theme) that survives reloads. */
export function usePersistentRef<T extends string | boolean>(key: string, initial: T): Ref<T> {
    return useStorage<T>(key, initial, safeStorage)
}
